/**
 * 
 * @param {string} value 
 * @returns 
 */
export const toGermanCurrency = (value) => {
    // Stelle sicher, dass der Wert als Zahl interpretiert wird
    let number = parseFloat(value);
    
    // Falls die Eingabe keine gültige Zahl ist, gebe eine Fehlermeldung zurück
    if (isNaN(number)) {
        //throw new Error("Ungültige Eingabe. Bitte eine Zahl übergeben.");
        return '';
    }
    
    // Formatieren der Zahl nach deutschem Währungsformat
    return number.toFixed(2).replace(".", ",");
}



/**
 * 
 * @param {string} value 
 * @returns 
 */
export const toPercent = (value) => {
    // Stelle sicher, dass der Wert als Zahl interpretiert wird
    let number = parseFloat(value);
    
    // Falls die Eingabe keine gültige Zahl ist, gebe eine Fehlermeldung zurück
    if (isNaN(number)) {
        //throw new Error("Ungültige Eingabe. Bitte eine Zahl übergeben.");
        return '';
    }
    
    // Formatieren der Zahl nach deutschem Währungsformat
    return number.toFixed(0);
}



/**
 * 
 * @param {string} value 
 * @returns
 */
export const toFloat = (value) => {
    return parseFloat(value.replace(",", "."));
} 